import React from 'react';

const AccountBadge = ({ letter, classes }) => {
  return (
    <div className={classes}>
      <p className="mb-0">{letter}</p>
    </div>
  );
};

AccountBadge.defaultProps = {
  classes: 'bg-info account-badge'
};

export default AccountBadge;
